import {defineStore} from "pinia";
import Translator from "@/utils/common/Translator.ts";
import {NamaWarning} from "@/utils/presenters/interfaces.ts";
import NaMaError = namaTypes.NaMaError;

export const useErrorsStore = defineStore({
  id: 'errorsStore',
  state: () => ({
    errors: new Array<namaTypes.NaMaError>(),
    lastServerLog: "",
    serverLogDialogVisible: false,
  }), actions: {
    pushErrors(errors: namaTypes.NaMaError[]) {
      this.addOrMoveErrorToEnd(...errors)
    },pushErrorStr(error: string) {
      const namaErrorText: namaTypes.NaMaText = {arabicText: error, englishText: error};
      const namaError: namaTypes.NaMaError = {message: namaErrorText};
      this.addOrMoveErrorToEnd(namaError);
    }, clearErrors() {
      this.errors.length = 0;
    },
    addOrMoveErrorToEnd(...errors: NaMaError[]) {
      for (const error of errors) {
        const index = this.errors.findIndex(err =>
          err.message?.englishText === error.message?.englishText &&
          err.message?.arabicText === error.message?.arabicText &&
          error.row === err.row && err.ownerId == error.ownerId)
        if (index !== -1)
          this.errors.splice(index, 1);
        this.errors.push(error)
      }
    },
    updateLastLog(log?: string) {
      if (!log)
        return;
      this.lastServerLog = log;
    }
  }
});

export const useMessagesStore = defineStore({
  id: 'messagesStore',
  state: () => ({
    messages: new Array<NamaWarning>()
  }), actions: {
    pushMessage(message: NamaWarning) {
      this.messages.push(message);
    }, pushMessages(messages: NamaWarning[]) {
      this.messages.push(...messages);
    }, pushMessageStr(message: string) {
      let namaMessageText: namaTypes.NaMaText = {arabicText: message, englishText: message};
      let namaMessage:NamaWarning = {message: namaMessageText};
      this.messages.push(namaMessage);
    }, clearMessages() {
      this.messages.length = 0;
    },
    showSuccessMessage() {
      this.pushMessageStr(Translator.translateId("operationSuccessfull"))
    }
  }
});

export const useNotificationsStore = defineStore({
  id: 'notificationsStore',
  state: () => ({
    notifications: new Array<namaTypes.DTOTabularResult>(),
  }), actions: {
    pushNotification(notification: namaTypes.DTOTabularResult) {
      this.notifications.push(notification);
    }, pushNotifications(notifications: namaTypes.DTOTabularResult[]) {
      this.notifications.push(...notifications);
    }, pushNotificationText(text: string) {
      let notification: namaTypes.DTOTabularResult = {
        values: {
          body: text
        }
      }
      this.notifications.push(notification);
    }, clearNotifications() {
      this.notifications.length = 0;
    }
  }
});

export const useTooltipsStore = defineStore({
  id: 'tooltipsStore',
  state: () => ({
    tooltips: new Array<namaTypes.NaMaError>(),
  }), actions: {
    pushTooltipStr(text: string) {
      this.tooltips = [];
      let namaMessageText: namaTypes.NaMaText = {arabicText: text, englishText: text};
      let tooltip: namaTypes.NaMaError = {message: namaMessageText};
      this.tooltips.push(tooltip);
    }, clearTooltips() {
      this.tooltips.length = 0;
    }
  }
});
